import { createSelector } from 'reselect'
import { propOr } from 'ramda'

const getCompliance = state => state.compliance

export const getComplianceTaskDomains = createSelector(
  getCompliance,
  propOr([], 'taskDomains')
)

export const getComplianceTaskDomainsLoading = createSelector(
  getCompliance,
  propOr(false, 'taskDomainsLoading')
)

export const getFlagSubmitting = createSelector(
  getCompliance,
  propOr(false, 'flagSubmitting')
)

export const getCreateObligationSubmitting = createSelector(
  getCompliance,
  propOr(false, 'createSubmitting')
)

export const getCreatedObligations = createSelector(
  getCompliance,
  propOr([], 'createdObligations')
)
